import React from 'react';
import { connect } from 'react-redux';
import ProgressBar from '../progress.bar';
import { getLoanApplication } from '../../selectors';
import moneyFormatter from 'money-formatter';
import PropTypes from 'prop-types';
import { Redirect } from "react-router-dom";
import { isEmpty } from "ramda";
import Section from '../Section/section';
import CheckYourRateForm from "../LoanApplication/CheckYourRateForm/checkYourRateForm";
import LoanApplicationHeader from '../LoanApplication/LoanApplicationHeader/loanApplicationHeader';
import { backButtonToLandingPage } from '../../actions';

export class OpenMarketCheckYourRatePage extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render = () => {
    const { loanApplication, backButtonToLandingPage } = this.props;
    if (!loanApplication.loanAmount || !loanApplication.loanPurpose || ( loanApplication.quotes && !isEmpty(loanApplication.quotes) )){
      backButtonToLandingPage();
      return <Redirect to="/apply" />;
    }
    return (
      <article>
        <LoanApplicationHeader title="Your loan details">
          <ul>
            <li>
              <h2>{moneyFormatter.format('USD', loanApplication.loanAmount, 0)}</h2>
              <p>Requested amount</p>
            </li>
          </ul>
        </LoanApplicationHeader>
        <Section>
          <header>
            <ProgressBar step="miniApp"/>
            <p className="font-weight-normal">Please fill in the fields below.</p>
          </header>
          <CheckYourRateForm />
        </Section>
      </article>
    );
  }
}

const mapStateToProps = state => ({
  loanApplication: getLoanApplication(state)
});

const mapDispatchToProps = { backButtonToLandingPage };

export default connect(mapStateToProps, mapDispatchToProps)(OpenMarketCheckYourRatePage);

OpenMarketCheckYourRatePage.propTypes = {
  loanApplication: PropTypes.shape({
    loanAmount: PropTypes.string.isRequired,
    loanPurpose: PropTypes.string.isRequired
  }).isRequired
};
